// externals
import { connect } from 'react-redux';

// selectors
import * as tradeInSelectors from '../../../store/mmd/tradeIn';

// actions
import * as tradeInActionCreators from '../../../store/actionCreators';

// consts/enums
import * as tradeInRoutes from '../../../utils/routes';
import { processStepperRoutes } from '../../../utils/tradeInDecisionLogic';
import { LOAN_BALANCE_OPTION_TYPES, LOAN_BALANCE_TRADE_IN_STEP, STEPPER_ROUTES, stepperRouteMap } from '../../../utils/constants';
import { isShowroomExperience } from '../../../utils/configUtils';

// components
import LoanBalanceOptionsUI from './LoanBalanceOptionsUI';

// interfaces/types
import { ILoanBalanceOptionsUIStateProps, ILoanBalanceOptionsUIDispatchProps } from './LoanBalanceOptionsInterfaces';
import { IRootProps } from '../../../components/RootProps';
import { StepperRoute } from '../../../types';

const mapStateToProps = (state: any, ownProps: IRootProps): ILoanBalanceOptionsUIStateProps => {
    const { tradeIn } = tradeInSelectors.getTradeInState(state, ownProps.tradeIndex);
    const isAmdLienPayoffQuoteSpOnSPEnabled = tradeInSelectors.isAmdLienPayoffQuoteEnabled(state);
    const { vehicle } = tradeIn;

    const vehicleName = `${vehicle.year} ${vehicle.make.name} ${vehicle.model.name}`;

    const pageTitle = 'Trade-In Vehicle';
    const pageSubTitle = 'Determine how much your current vehicle is worth, and apply that value to your new vehicle.';

    const isSalesView = isShowroomExperience(ownProps.config);
    const tradeInSource = tradeIn?.source;
    const selectedLoanBalanceOption = tradeInSelectors.getTradeInSelectedLoanBalanceOption(tradeIn);

    const selectedStepperRoute: StepperRoute[] = stepperRouteMap[tradeInSource] || STEPPER_ROUTES.loanBalance;
    const stepperRoutes = processStepperRoutes(
        state,
        selectedStepperRoute,
        isSalesView,
        isAmdLienPayoffQuoteSpOnSPEnabled,
        ownProps.tradeIndex,
        LOAN_BALANCE_TRADE_IN_STEP,
        tradeInRoutes.TRADE_LOAN_BALANCE_OPTIONS
    );

    return {
        vehicle,
        vehicleName,
        pageTitle,
        pageSubTitle,
        stepperRoutes,
        tradeInSource,
        selectedLoanBalanceOption,
        tradeIndex: ownProps.tradeIndex,
        urlPath: ownProps.tradeInRoute
    };
};

const mapDispatchToProps = (dispatch: any, ownProps: IRootProps): ILoanBalanceOptionsUIDispatchProps => {
    return {
        dispatchAnalytics: (type: string, description: string) => {
            dispatch(tradeInActionCreators.dispatchAnalytics(type, description));
        },
        goToRoute: (route: string) => {
            dispatch(tradeInActionCreators.updateTradeInCurrentLocation(route));
        },
        next: (selectedLoanBalanceOption: string) => {
            const nextRoute =
                selectedLoanBalanceOption === LOAN_BALANCE_OPTION_TYPES.FIND_OPEN_AUTO_LOAN
                    ? tradeInRoutes.TRADE_REGISTRATION_DETAILS
                    : tradeInRoutes.TRADE_ESTIMATE_LOAN_BALANCE;
            dispatch(tradeInActionCreators.updateTradeInCurrentLocation(nextRoute));
            dispatch(tradeInActionCreators.cdlLoanBalanceOptionNextButtonClicked(selectedLoanBalanceOption));
        },
        goBack: () => {
            dispatch(tradeInActionCreators.updateTradeInCurrentLocation(tradeInRoutes.TRADE_LOAN_BALANCE));
        },
        onSelectLoanBalanceOption: (selectedLoanBalanceOption: string) => {
            dispatch(tradeInActionCreators.setLoanBalanceOption(selectedLoanBalanceOption));

            dispatch(
                tradeInActionCreators.dispatchAnalytics(
                    'DR_TRADEIN_LOAN_BALANCE_OPTION_SELECTED',
                    `Loan Balance Option selected: ${selectedLoanBalanceOption}`
                )
            );
            dispatch(tradeInActionCreators.cdlLoanBalanceOptionCardSelected(selectedLoanBalanceOption));
        },
        removeTradeIn: () => {
            dispatch(tradeInActionCreators.updateTradeInCurrentLocation(tradeInRoutes.TRADE_IN));
            dispatch(tradeInActionCreators.removeTradeIn());
        },
        cdlBackButtonClicked: () => {
            dispatch(tradeInActionCreators.cdlBackButtonClicked(LOAN_BALANCE_TRADE_IN_STEP));
        },
        cdlCancelTradeInButtonClicked: () => {
            dispatch(tradeInActionCreators.cdlCancelTradeInButtonClicked(LOAN_BALANCE_TRADE_IN_STEP));
        }
    };
};

const LoanOptions = connect(mapStateToProps, mapDispatchToProps)(LoanBalanceOptionsUI);

export default LoanOptions;
